import { useEffect } from "react";
import styled from "styled-components";
import AboutSession from "./components/AboutSession";
import GetStarted from "./components/GetStarted";
import HeroSession from "./components/HeroSession.js/HeroSession";
import { OurProduct } from "./components/OurProduct";
import { Partners } from "./components/Partners";
import Shield from "./components/Shield/Shield";
// import { Testimonial } from "./components/Testimonial"
import Nav from "../../components/navbar/Nav";
import Footer from "../../components/footer/Footer";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <StickNav>
        <Nav />
      </StickNav>
      <HeroSession />
      <Shield />
      <AboutSession />
      <OurProduct />
      {/* <Testimonial/> */}
      <Partners />
      <GetStarted />
      <Footer />
    </>
  );
};

export default Home;

// export const HomeContainer =  styled.div`
//   overflow-x: hidden;
// `
export const StickNav = styled.div`
  position: fixed;
  width: 100%;
  transform: translateY(-6rem);
  margin-bottom: 2rem;
  z-index: 10000;
`;
